import { forwardRef, Ref } from 'react';

import { styled } from '@mui/material';

import Button, { Props as ButtonProps } from '../../../components/Button';
import ChevronRightIcon from '../../../icons/ChevronRightIcon';
import { inputBaseClasses } from '../../../components/FormControls/TextFieldBase/styles';
import TextField from '../../../components/HookFormControls/TextField';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  [`& .${inputBaseClasses.root}`]: {
    backgroundColor: theme.palette.grey[50],
  },
  [`& .${inputBaseClasses.input}`]: {
    fontSize: theme.typography.pxToRem(14),
  },
})) as typeof TextField;

export const NextButton = styled(
  forwardRef((props: ButtonProps, ref: Ref<HTMLButtonElement>) => (
    <Button variant="contained" endIcon={<ChevronRightIcon />} {...props} ref={ref} />
  ))
)(() => ({
  minWidth: 120,
}));
